import { TEST_VERTICAL_PRIVATE_WIDGET } from '../ids';
import { InstallLocation } from '../types';
export const ids = TEST_VERTICAL_PRIVATE_WIDGET;
export const getDefinition = () => ({
    ...TEST_VERTICAL_PRIVATE_WIDGET,
    method: 'addApplication',
    installLocation: InstallLocation.Standalone,
    loginMenuTitle: 'Test Private Widget',
    showInLoginMenu: true,
    social: false,
    urlOverride: 'test-private-widget',
    shouldInstallInitially: true,
});
//# sourceMappingURL=test-vertical-private-widget.js.map